'use strict';

module.exports = [
    {
        value: 'en',
        name: 'English'
    },
    {
        value: 'de',
        name: 'Deutsch (Deutsch)'
    },
    {
        value: 'fr',
        name: 'French (Français)'
    },
    {
        value: 'ru',
        name: 'Russian (Русский)'
    },
    {
        value: 'es',
        name: 'Spanish (Español)'
    },
    {
        value: 'nl',
        name: 'Dutch (Nederlands)'
    },
    {
        value: 'it',
        name: 'Italian (Italiano)'
    },
    {
        value: 'uk',
        name: 'Ukrainian (Український)'
    },
    {
        value: 'el',
        name: 'Greek (Ελληνικά)'
    },
    {
        value: 'bg',
        name: 'Bulgarian (Български)'
    },
    {
        value: 'hy',
        name: 'Armenian (հայերեն)'
    },
    {
        value: 'ka',
        name: 'Georgian (ქართული)'
    },
    {
        value: 'pl',
        name: 'Polish (Polskie)'
    },
    {
        value: 'tr',
        name: 'Turkish (Türkçe)'
    },
    {
        value: 'sl',
        name: 'Slovenian (Slovenski)'
    },
    {
        value: 'pt',
        name: 'Portuguese (Português)'
    },
    {
        value: 'et',
        name: 'Estonian (Eesti keel)'
    },
    {
        value: 'lv',
        name: 'Latvian (Latviešu)'
    }
];
